import { render, staticRenderFns } from "./DocumentScanPage.vue?vue&type=template&id=451f0060&"
import script from "./DocumentScanPage.vue?vue&type=script&lang=js&"
export * from "./DocumentScanPage.vue?vue&type=script&lang=js&"
import style0 from "./DocumentScanPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports